import React, { useMemo, useState } from 'react';
import {
	useEducationMaterialsQuery,
	useQuestionnairesQuery,
} from '../../../../../graphql/graphql';
import { SelectValue } from '../../../../../Components/Base/Select/Select';
import { FieldError } from 'react-hook-form';
import MultiSelectWithCheckList from '../../../../Base/Components/Inputs/MultiSelectWithCheckList/MultiSelectWithCheckList';
import Loading from '../../../../../Components/Loading';
import { useAppContext } from '../../../../../Services/AppContext';

interface Props {
	onChange?: (value: SelectValue) => void;
	workplaceId?: string;
	value?: SelectValue;
	error?: FieldError;
	placeholder?: string;
	portal?: boolean;
	isSearchable?: boolean;
}

const EducationMaterialMultiSelectWithCheckList: React.FC<Props> = props => {
	const { value, onChange, portal, isSearchable } = props;
	const [defaultValue, setDefaultValue] = useState<SelectValue | undefined>(
		value,
	);
	const { workplaceId } = useAppContext();

	const { data, isLoading } = useEducationMaterialsQuery({
		workplaceId,
		pagination: {
			take: 999,
		},
	});

	const options: SelectValue[] = useMemo(() => {
		const items: SelectValue[] = [];

		data?.educationMaterials?.data?.forEach((item: any) => {
			if (item?.name && item?.id) {
				items.push({
					label: item.name,
					value: item.id,
				});
			}
		});

		return items;
	}, [data]);

	if (isLoading) {
		return <Loading />;
	}

	return (
		<MultiSelectWithCheckList
			{...props}
			options={options}
			onChange={onChange}
			value={defaultValue?.label ? defaultValue : value}
			portal={portal}
			isSearchable={isSearchable}
			showItemsCounting={false}
		/>
	);

	return null;
};

export default EducationMaterialMultiSelectWithCheckList;
